import { dynamics } from "@/mocks/dynamics";

export default function LatestDynamics() {
  return (
    <section
      id="dynamics"
      className="mx-auto max-w-6xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16"
    >
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs font-semibold tracking-widest text-secondary-700">
            LATEST
          </p>
          <h2 className="mt-1 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            最新动态
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            编辑部按时间滚动更新各人物档案的核实进展、回应口径与关系图谱变化，事件有进展，这里随时跟进。
          </p>
        </div>
        <span className="hidden shrink-0 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900 sm:inline">
          每日滚动更新
        </span>
      </div>

      <ol className="relative mt-8 border-l border-background-200 pl-6 md:pl-8">
        {dynamics.map((d) => (
          <li key={d.date + d.title} className="relative pb-8 last:pb-0">
            <span className="absolute -left-[1.78rem] top-1.5 h-3 w-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
              <span className="font-display text-sm font-bold text-primary-600">
                {d.date}
              </span>
              <span className="inline-flex w-fit rounded-full px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                {d.tag}
              </span>
            </div>
            <h3 className="mt-2 font-display text-base font-bold text-foreground-950">
              {d.title}
            </h3>
            <p className="mt-1.5 max-w-3xl text-sm leading-relaxed text-foreground-700">
              {d.text}
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
}